import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Switch, Cascader, Spin, message, InputNumber } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolPermission from '../../tools/ToolPermission';

import SpinFull from '../../components/SpinFull';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

export default function FarmCropAddScreen(props) {
  const history = useHistory();
  const userData = useSelector(state => state.user);
  const userPermissionsData = useSelector(state => state.userPermissions);

  const isAllowedCrossCompany = ToolPermission.hasPermission(userPermissionsData, 'ui:company', 'get:xc');

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const companyRes = isAllowedCrossCompany ? (await ToolRequest.request('GET', '/v1/company', {
        count: 1000,
      })) : {
        data: [await ToolRequest.request('GET', `/v1/company/${userData.companyId}`)],
      };

      setCompanyOptions(companyRes.data.map(company => ({
        value: company.id,
        label: `${company.displayName} (${company.name})`,
      })));

      setLoaded(true);
    })();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      await ToolRequest.request('POST', '/v1/farm-crop', {
        companyId: values.companyId[0],
        name: values.name,
        seedlingDayCount: values.seedlingDayCount,
        plantingDayCount: values.plantingDayCount,
        remarks: values.remarks,
        isEnabled: values.isEnabled,
      });

      message.success('Create Crop successfully');

      history.push('/farm-crop');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  return loaded ? (
    <PageHeader
      title="Add a Crop"
      onBack={() => history.push('/farm-crop')}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          initialValues={{
            companyId: isAllowedCrossCompany ? [] : [companyOptions[0].value],
            seedlingDayCount: 14,
            plantingDayCount: 21,
            isEnabled: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Company"
            name="companyId"
            rules={[
              {
                required: isAllowedCrossCompany,
                message: 'Please select a company',
              },
            ]}
          >
            <Cascader
              options={companyOptions}
              disabled={!isAllowedCrossCompany}
            />
          </Form.Item>

          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter the name',
              },
            ]}
          >
            <Input
              placeholder="Name"
            />
          </Form.Item>

          <Form.Item
            label="Propagation Days"
            name="seedlingDayCount"
            rules={[
              {
                required: true,
                message: 'Please enter the propagation days',
              },
            ]}
          >
            <InputNumber
              placeholder="Days"
              min={1}
            />
          </Form.Item>

          <Form.Item
            label="Grow Days"
            name="plantingDayCount"
            rules={[
              {
                required: true,
                message: 'Please enter the grow days',
              },
            ]}
          >
            <InputNumber
              placeholder="Days"
              min={1}
            />
          </Form.Item>

          <Form.Item
            label="Remarks"
            name="remarks"
          >
            <Input.TextArea
              placeholder="Remarks"
            />
          </Form.Item>

          <Form.Item
            label="Enabled"
            name="isEnabled"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
};
